import { Routes } from '@angular/router';
import { AttachmentsGuard } from './app/guards/attachments.guard';
import { AuthGuard } from './app/guards/auth.guard';
import { ContractsGuard } from './app/guards/contracts.guard';
import { DocumentsGuard } from './app/guards/documents.guard';
import { HrDocumentationGuard } from './app/guards/hrdocumentation.guard';
import { LoginGuard } from './app/guards/login.guard';
import { MobileGuard } from './app/guards/mobile.guard';
import { MyDocumentsGuard } from './app/guards/mydocuments.guard';
import { PreEmploymentSelfserviceGuard } from './app/guards/pre-employment-selfservice.guard';
import { PrizeContestMobileGuard } from './app/guards/prize-contest.guard';
import { SelfServicesGuard } from './app/guards/selfservices.guard';
import { translationResolver } from './app/guards/translation.resolver';
import { AppLayout } from './app/layout/component/app.layout';
import { CallbackComponent } from './app/pages/callback/callback';
import { HrDocumentationMobileComponent } from './app/pages/hr-documentation-mobile/hr-documentation-mobile.component';
import { MyDocumentsMobileComponent } from './app/pages/my-documents-mobile/my-documents.component';
import { Notfound } from './app/pages/notfound/notfound';
import { OpenMobileAppOrProd } from './app/pages/open-mobile-app-or-prod/open-mobile-app-or-prod';
import { PreEmploymentSelfserviceMobileComponent } from './app/pages/pre-employment-selfservice-mobile/pre-employment-selfservice-mobile.component';
import { PreEmploymentActivitiesComponent } from './app/pages/pre-employment/pre-employment-activities/pre-employment-activities.component';

export const appRoutes: Routes = [
  // ROUTES FOR DESKTOP
  { path: 'open-mobile-app-or-prod', component: OpenMobileAppOrProd },
  {
    path: '',
    component: AppLayout,
    canActivate: [MobileGuard, AuthGuard],
    canActivateChild: [MobileGuard, AuthGuard],
    resolve: { translation: translationResolver },
    children: [
      { path: '', loadChildren: () => import('./app/pages/pages.routes') },
    ],
  },
  { path: 'callback', component: CallbackComponent },
  {
    path: 'auth',
    loadChildren: () => import('./app/pages/auth/auth.routes'),
    canActivate: [LoginGuard, MobileGuard],
    canActivateChild: [LoginGuard, MobileGuard],
    resolve: { translation: translationResolver },
  },
  {
    path: 'acceptance',
    loadChildren: () => import('./app/pages/contracts/contracts.routes'),
    canActivate: [],
    resolve: { translation: translationResolver },
  },
  {
    path: 'hiring',
    canActivate: [LoginGuard, MobileGuard],
    canActivateChild: [LoginGuard, MobileGuard],
    children: [
      {
        path: 'activities',
        component: PreEmploymentActivitiesComponent,
      },
      {
        path: '',
        redirectTo: 'activities',
        pathMatch: 'full',
      }
    ]
  },

  // ROUTES FOR APP MOBILE
  {
    path: 'selfservice',
    loadChildren: () => import('./app/pages/selfservices/selfservices.routes'),
    canActivate: [SelfServicesGuard],
    resolve: { translation: translationResolver },
  },
  {
    path: 'documents',
    loadChildren: () => import('./app/pages/documents/documents.routes'),
    canActivate: [DocumentsGuard],
    resolve: { translation: translationResolver },
  },
  {
    path: 'attachments',
    loadChildren: () => import('./app/pages/attachments/attachments.routes'),
    canActivate: [AttachmentsGuard],
    resolve: { translation: translationResolver },
  },
  {
    path: 'contracts',
    loadChildren: () => import('./app/pages/contracts-mobile/contracts-mobile.routes'),
    canActivate: [ContractsGuard],
    resolve: { translation: translationResolver },
  },
  {
    path: 'prize-contests',
    loadChildren: () => import('./app/pages/prize-contests-mobile/prize-contests-mobile.routes'),
    canActivate: [PrizeContestMobileGuard],
    resolve: { translation: translationResolver },
  },
  {
    path: 'my-documents-mobile',
    component: MyDocumentsMobileComponent,
    canActivate: [MyDocumentsGuard],
    resolve: { translation: translationResolver },
  },
  {
    path: 'hr-documentation-mobile',
    component: HrDocumentationMobileComponent,
    canActivate: [HrDocumentationGuard],
    resolve: { translation: translationResolver },
  },
  {
    path: 'auth',
    loadChildren: () => import('./app/pages/auth/auth.routes'),
    canActivate: [LoginGuard, MobileGuard],
    canActivateChild: [LoginGuard, MobileGuard],
    resolve: { translation: translationResolver },
  },
  {
    path: 'pre-employment-selfservice',
    component: PreEmploymentSelfserviceMobileComponent,
    canActivate: [PreEmploymentSelfserviceGuard],
    resolve: { translation: translationResolver },
  },
  { path: 'notfound', component: Notfound },
  { path: '**', redirectTo: '/notfound' },
];
